module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showHeader) ? _c('div', {
    class: {
      'supima-menu': _vm.callerComp === 'supimaMenu',
      'activewear-menu': _vm.callerComp === 'activeWearMenu',
      'birthday-logo': _vm.isBirthdayMonth
    }
  }, [_c('div', {
    staticClass: "notifylogin",
    attrs: {
      "id": "notifylogin"
    }
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.userAcc.loader) ? _c('div', {
    staticClass: "loadingOverlay"
  }, [_c('div', {
    staticClass: "loading"
  })]) : _vm._e(), _vm._v(" "), (!['supimaMenu', 'activeWearMenu'].includes(_vm.callerComp)) ? _c('div', {
    staticClass: "topbar img-auto",
    class: {
      bgOrange: _vm.$route.path === '/membership'
    }
  }, [_c('div', {
    staticClass: "container py-1",
    class: _vm.bannerPlaceHolderForAppDownldPopup ? 'goAppOnlySale' : ''
  }, [((this.getSystemBrowser() !== 'safari') && _vm.bannerPlaceHolderForAppDownldPopup && !_vm.isBflUtm && !_vm.bannerPlaceHolderForGoForAppOnlySale) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-white d-flex justify-content-end align-items-center justify-content-center",
    class: (this.getSystemBrowser() === 'safari') ? 'py-1' : 'py-2'
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n            " + _vm._s(_vm.bannerPlaceHolderForAppDownldPopup && _vm.bannerPlaceHolderForAppDownldPopup.tag_text) + "\n          ")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "pointer text-uppercase p-1",
    staticStyle: {
      "border": "2px solid #fff",
      "border-radius": "6px"
    },
    on: {
      "click": _vm.appOpenHandler
    }
  }, [_vm._v("\n               \n              "), _c('i', {
    staticClass: "fa fa-mobile mr-1",
    staticStyle: {
      "font-size": "15px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Open App \n            ")])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-toggleable-md navbar-light bg-faded"
  }, [(!_vm.bannerPlaceHolderForGoForAppOnlySale && _vm.$route.name === 'home' || ['supimaMenu', 'activeWearMenu'].includes(_vm.callerComp)) ? _c('button', {
    staticClass: "navbar-toggler navbar-toggler-left newmobilenav",
    attrs: {
      "aria-label": "navigation menu",
      "type": "button"
    },
    on: {
      "click": _vm.navCategoriesRequestHandler
    }
  }, [(_vm.$route.name === 'home') ? _c('span', {
    staticClass: "navbar-toggler-icon"
  }) : _c('span', {
    staticClass: "menu-hamburger"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/hamburger-white.png")
    }
  })])]) : _c('div', {
    staticClass: "navbar-toggler-left toggle-menu left-arrow-style"
  }, [(!_vm.bannerPlaceHolderForGoForAppOnlySale) ? _c('img', {
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/icons/back_arrow.png",
      "alt": "Arrow"
    },
    on: {
      "click": _vm.goToPreviousPage
    }
  }) : _vm._e()]), _vm._v(" "), (this.$route.name === 'listing' || this.$route.name === 'search' || this.$route.name === 'mywishlist') ? _c('div', {
    staticClass: "pl-4",
    class: [this.$route.name === 'mywishlist' ? 'pr-1' : 'pr-5', _vm.productListingStyle.fontPosition ? ("text-" + (_vm.productListingStyle.fontPosition)) : '']
  }, [_c('span', {
    staticClass: "pl-3 pr-5 txtTruncate font-weight-bold text-capitalize",
    class: _vm.productListingHeader.subHeader ? '' : 'pt-1',
    staticStyle: {
      "color": "#191919"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.productListingHeader.header) + "\n      ")]), _vm._v(" "), (_vm.productListingHeader.subHeader) ? _c('span', {
    staticClass: "pl-2 pr-5 txtTruncate text-capitalize",
    staticStyle: {
      "line-height": "1",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.productListingHeader.subHeader))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.bannerPlaceHolderForGoForAppOnlySale),
      expression: "!bannerPlaceHolderForGoForAppOnlySale"
    }],
    staticClass: "headerRight"
  }, [_c('div', [_c('span', {
    staticClass: "hicon",
    on: {
      "click": function($event) {
        _vm.openSearch()
      }
    }
  }, [(['supimaMenu', 'activeWearMenu'].includes(_vm.callerComp)) ? _c('img', {
    staticStyle: {
      "width": "27px !important"
    },
    attrs: {
      "src": require("./assets/images/search-white.png"),
      "alt": "search"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.imgBaseUrl + 'appIcons/ic_search@2x.png',
      "alt": "search"
    }
  })]), _vm._v(" "), (!_vm.disableWishlist && _vm.$route.name !== 'mywishlist') ? _c('router-link', {
    staticClass: "hicon",
    attrs: {
      "to": '/mywishlist'
    },
    nativeOn: {
      "click": function($event) {
        _vm.myWishlistVisitEventHandler('default')
      }
    }
  }, [(['supimaMenu', 'activeWearMenu'].includes(_vm.callerComp)) ? _c('span', {
    staticClass: "headercart hicon fa heart",
    class: this.$router.currentRoute.path === '/mywishlist' ? 'fa-heart-o active' : 'fa-heart-o'
  }) : _c('span', {
    staticClass: "headercart hicon"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgBaseUrl + 'appIcons/ic_wishlist@2x.png',
      "alt": "wishlist"
    }
  })]), _vm._v(" "), (_vm.wishlistCount > 0) ? _c('div', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.wishlistCount))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "hicon",
    attrs: {
      "to": '/cart'
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeBlackShow()
      }
    }
  }, [_c('span', {
    on: {
      "click": _vm.cartEventHandler
    }
  }, [(['supimaMenu', 'activeWearMenu'].includes(_vm.callerComp)) ? _c('svg', {
    staticClass: "mt-1 headercart",
    staticStyle: {
      "stroke": "#fff",
      "fill": "#fff",
      "stroke-width": "1.4",
      "-webkit-font-smoothing": "antialiased"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "25",
      "height": "23",
      "viewBox": "0 0 48 48"
    }
  }, [_c('path', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "d": "M43,46H5c-2.209,0-4-1.791-4-4l4-24c0.678-3.442,2.668-4,4.877-4h2.652  C14.037,7.052,18.602,2,24,2s9.963,5.052,11.471,12h2.652c2.209,0,4.199,0.558,4.877,4l4,24C47,44.209,45.209,46,43,46z M24,4  c-4.352,0-8.045,4.178-9.418,10h18.837C32.045,8.178,28.353,4,24,4z M41,18c-0.308-1.351-0.957-2-2.37-2h-2.828  C35.925,16.976,36,17.975,36,19c0,0.552-0.447,1-1,1s-1-0.448-1-1c0-1.027-0.069-2.031-0.201-3H14.201C14.07,16.969,14,17.973,14,19  c0,0.552-0.447,1-1,1s-1-0.448-1-1c0-1.025,0.075-2.024,0.197-3H9.369C7.957,16,7.309,16.649,7,18L3,42c0,1.104,0.896,2,2,2h38  c1.104,0,2-0.896,2-2L41,18z",
      "shape-rendering": "auto"
    }
  }), _vm._v(" "), _c('line', {
    staticStyle: {
      "stroke-width": "3"
    },
    attrs: {
      "x1": "5",
      "y1": "32",
      "x2": "44",
      "y2": "32"
    }
  })]) : _c('img', {
    attrs: {
      "src": _vm.imgBaseUrl + 'appIcons/ic_newCart@2x.png',
      "alt": "cart"
    }
  }), _vm._v(" "), (_vm.cartcount > 0) ? _c('div', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.cartcount))]) : _vm._e()])])], 1)]), _vm._v(" "), (this.$route.name !== 'listing' && this.$route.name !== 'search' && this.$route.name !== 'mywishlist') ? _c('div', {
    class: ['supimaMenu', 'activeWearMenu'].includes(_vm.callerComp) ? 'pabsolute supima-home-logo' : 'navbar-brand',
    on: {
      "click": function($event) {
        _vm.homeEventHandler(_vm.webcategory && _vm.isComboActive ? '/' + _vm.webcategory : '/')
      }
    }
  }, [(['supimaMenu', 'activeWearMenu'].includes(_vm.callerComp)) ? _c('img', {
    attrs: {
      "src": _vm.callerComp === 'supimaMenu' ? _vm.imgBaseUrl + 'supima-home-logo.png' : _vm.imgBaseUrl + 'active-wear-logo-mob.png'
    }
  }) : _vm._e(), _vm._v("\n       \n    ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "collapse navbar-collapse stylescrollbar navMenu",
    class: !['supimaMenu', 'activeWearMenu'].includes(_vm.callerComp) ? 'navbar-mt' : '',
    attrs: {
      "id": "navbarNavDropdown"
    }
  }, [_c('div', {
    staticClass: "navheader showmobile"
  }, [_c('div', {
    staticClass: "row header-background"
  }, [_c('div', {
    staticClass: "navbar-toggler-left toggle-menu left-arrow-style",
    staticStyle: {
      "top": "20px"
    },
    on: {
      "click": function($event) {
        _vm.setHomeMenu(_vm.webcategory)
      }
    }
  }, [_c('img', {
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/icons/back_arrow.png",
      "alt": "Arrow"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-sm-3 col-md-2 d-flex align-items-center",
    staticStyle: {
      "left": "38%"
    }
  }, [_c('router-link', {
    staticClass: "toggle-menu",
    attrs: {
      "to": _vm.webcategory && _vm.isComboActive ? '/' + _vm.webcategory : '/'
    }
  }, [_vm._v(" \n                "), _c('img', {
    staticClass: "sidebar-home-img",
    attrs: {
      "data-src": _vm.exclusiveUser ? 'https://prod-img.thesouledstore.com/public/theSoul/images/exclusive/MemebrIcon_On.png' : '/static/img/newlogosticky.f7f01f0.png',
      "alt": "The Souled Store Logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "headerRight mt-2"
  }, [_c('div', [_c('span', {
    staticClass: "hicon",
    on: {
      "click": function($event) {
        _vm.openSearch()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgBaseUrl + 'appIcons/ic_search@2x.png',
      "alt": "search"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "hicon",
    attrs: {
      "to": '/cart'
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeBlackShow()
      }
    }
  }, [_c('span', {
    on: {
      "click": _vm.cartEventHandler
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgBaseUrl + 'appIcons/ic_newCart@2x.png',
      "alt": "cart"
    }
  }), _vm._v(" "), (_vm.cartcount > 0) ? _c('div', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.cartcount))]) : _vm._e()])])], 1)])])]), _vm._v(" "), (_vm.isCategoryRequested) ? _c('categories', {
    attrs: {
      "moreSectionId": "collapseMoreNav"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  })]), _vm._v(" "), _c('div', [(_vm.togglesearch) ? _c('div', {
    staticClass: "mobilesearch"
  }, [_c('div', {
    staticClass: "mbinput"
  }, [_c('autocomplete', {
    attrs: {
      "trigger": _vm.trigger,
      "searchTerm": _vm.searchTerm
    }
  })], 1)]) : _vm._e()])]), _vm._v(" "), (!_vm.bannerPlaceHolderForGoForAppOnlySale && (_vm.$route.path === '/men' || _vm.$route.path === '/women' || _vm.$route.path === '/kids')) ? _c('div', {
    staticClass: "row home-gender-wrapper"
  }, [_c('div', {
    staticClass: "col",
    class: _vm.$route.path === '/men' ? 'home-active-tab-class' : '',
    staticStyle: {
      "padding-top": "0.1rem"
    }
  }, [_c('button', {
    staticClass: "tab-btn pt-1 pb-1 men ",
    style: (_vm.$route.path === '/men' ? 'font-weight: 600' : ''),
    on: {
      "click": function($event) {
        _vm.setHomeMenu('men')
      }
    }
  }, [_vm._v("\n          Men\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col",
    class: _vm.$route.path === '/women' ? 'home-active-tab-class' : '',
    staticStyle: {
      "padding-top": "0.1rem"
    }
  }, [_c('button', {
    staticClass: "tab-btn pt-1 pb-1 women",
    style: (_vm.$route.path === '/women' ? 'font-weight: 600' : ''),
    on: {
      "click": function($event) {
        _vm.setHomeMenu('women')
      }
    }
  }, [_vm._v("\n          Women\n        ")])]), _vm._v(" "), (_vm.bannerPlaceHolderForKidsWebCategory) ? _c('div', {
    staticClass: "col",
    class: _vm.$route.path === '/kids' ? 'home-active-tab-class' : '',
    staticStyle: {
      "padding-top": "0.1rem"
    }
  }, [_c('button', {
    staticClass: "tab-btn pt-1 pb-1 men ",
    style: (_vm.$route.path === '/kids' ? 'font-weight: 600' : ''),
    on: {
      "click": function($event) {
        _vm.setHomeMenu('kids')
      }
    }
  }, [_vm._v("\n          Kids\n        ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.loginModel) ? _c('login-modal', {
    on: {
      "close": function($event) {
        _vm.userAcc.loginBox = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.oTrack) ? _c('order-track', {
    on: {
      "close": function($event) {
        _vm.oTrack = false
      }
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bff55c4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/AppNavNewMobile.vue
// module id = 2574
// module chunks = 65